import {
  SET_ISSUE_NODES_LOADER,
  LOAD_ISSUE_NODES,
  APPEND_ISSUE_NODES,
  SET_ISSUE_NODES_CURSOR,
} from '../../config/actions';

const initialState = {
  loading: false,
  list: [],
  nextCursor: null,
};

export default function issueNodesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ISSUE_NODES_LOADER:
      return { ...state, loading: action.payload };

    case LOAD_ISSUE_NODES:
      return { ...state, list: action.payload };

    case APPEND_ISSUE_NODES:
      return { ...state, list: [...state.list, ...action.payload] };

    case SET_ISSUE_NODES_CURSOR:
      return { ...state, nextCursor: action.payload };

    default:
      return state;
  }
}
